import { render } from "./DeleteProfileForm.vue?vue&type=template&id=d7afdc54"
import script from "./DeleteProfileForm.vue?vue&type=script&lang=js"
export * from "./DeleteProfileForm.vue?vue&type=script&lang=js"

import "./DeleteProfileForm.vue?vue&type=style&index=0&id=d7afdc54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__